export default {
  bind(el, binding, vnode) {
    el.onClickOutside = (e) => {
      if (!(el === e.target || el.contains(e.target))) {
        vnode.context[binding.expression](e);
      }
    };
    document.body.addEventListener('click', el.onClickOutside);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.onClickOutside);
  },
};
